import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative px-6 py-12 md:py-16 overflow-hidden bg-navy" data-id="element-47">
      {/* Subtle background glows */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-gold/5 blur-3xl rounded-full pointer-events-none" data-id="element-48"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-sage/5 blur-3xl rounded-full pointer-events-none" data-id="element-49"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-50">
        <FadeIn data-id="element-51">
          <span className="text-gold/80 font-medium tracking-widest text-xs md:text-sm uppercase mb-3 block" data-id="element-52">
            Una guía práctica y espiritual
          </span>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl text-cream leading-tight mb-4" data-id="element-53">
            MÉTODO 7-D MORNINGS:
            <br data-id="element-54" />
            <span className="italic text-cream/90" data-id="element-55">
              El Despertar de la Gracia
            </span>
          </h1>
          <div className="h-px w-16 bg-gold/30 mx-auto mb-4" data-id="element-56"></div>
        </FadeIn>

        {/* Emotional copy block */}
        <FadeIn delay={0.15} className="max-w-2xl mx-auto mb-6" data-id="element-57">
          <p className="text-xl md:text-2xl font-serif font-bold text-cream leading-snug" data-id="element-58">
            No es pereza.
          </p>
          <p className="text-xl md:text-2xl font-serif font-bold text-cream leading-snug mb-3" data-id="element-59">
            No es falta de fe.
          </p>
          <p className="text-lg md:text-xl font-serif font-normal text-cream/80 leading-relaxed" data-id="element-60">
            Es un sistema nervioso que aprendió
          </p>
          <p className="text-lg md:text-xl font-serif font-normal text-cream/80 leading-relaxed mb-3" data-id="element-61">
            que la mañana es una amenaza.
          </p>
          <p className="text-base md:text-lg font-serif text-cream/60 leading-relaxed mb-2" data-id="element-62">
            Y nadie te enseñó cómo desactivarlo.
          </p>
          <p className="text-2xl md:text-3xl font-serif italic text-gold/90 tracking-wide" data-id="element-63">
            Hasta hoy.
          </p>
        </FadeIn>

        {/* Product mockup image */}
        <FadeIn delay={0.3} className="relative max-w-xs mx-auto mb-8" data-id="element-64">
          <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl shadow-black/20" data-id="element-65">
            <img src="https://cdn.magicpatterns.com/uploads/fzHyLZJbNMep58WjHsxjsC/heylloyd-image-1775939581053.png" alt="Método 7-D Mornings en iPad" className="w-full h-auto object-cover" data-id="element-66" />
          </div>
          <div className="absolute -top-4 -right-4 w-20 h-20 bg-sage/10 rounded-full blur-xl -z-10" data-id="element-67"></div>
          <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-gold/10 rounded-full blur-xl -z-10" data-id="element-68"></div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-69">
          <CTAButton variant="light" data-id="element-70">QUIERO RECUPERAR MIS MAÑANAS</CTAButton>
        </FadeIn>
      </div>
    </section>;
}